import React from 'react';
import { useDynamicHeroImage } from 'hooks/useDynamicHeroImages';
import AddThisSocialSharing from 'components/AddThisSocialSharing';
import { WebinarLayoutContainer } from './styles';

const WebinarLayout = ({ children, showAddSocial, otherProps }) => {
  const backgroundImg = useDynamicHeroImage('bg-main-white-short');
  return (
    <WebinarLayoutContainer backgroundImage={backgroundImg?.file?.url} {...otherProps}>
      <div className="webinar-layout-container--wrapper">
        {showAddSocial && <AddThisSocialSharing placement="topLeftSticky" />}
        <div className="webinar-layout-container--content-wrapper">{children}</div>
      </div>
    </WebinarLayoutContainer>
  );
};

export default WebinarLayout;
